import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';

const StickyContactButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling past hero section (roughly 600px)
      setIsVisible(window.scrollY > 600);
    };

    window.addEventListener('scroll', handleScroll);
    // Check initial scroll position
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const kontaktElement = document.querySelector('#kontakt');
    if (kontaktElement) {
      kontaktElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button
      onClick={scrollToContact}
      data-testid="sticky-contact-button"
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-sun-orange hover:bg-sun-orange-dark text-white px-6 py-4 rounded-full shadow-xl shadow-sun-orange/30 transition-all duration-300 font-semibold hover:scale-105 ${
        isVisible ? 'translate-y-0 opacity-100 pointer-events-auto' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
      aria-label="Beratung anfragen"
    >
      <Phone className="w-5 h-5" />
      <span className="hidden sm:inline">Beratung anfragen</span>
    </button>
  );
};

export default StickyContactButton;
